/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { cbrtDependencies } from './dependenciesCbrt.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { imDependencies } from './dependenciesIm.generated.js';
import { isZeroDependencies } from './dependenciesIsZero.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { reDependencies } from './dependenciesRe.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractDependencies } from './dependenciesSubtract.generated.js';
import { typeOfDependencies } from './dependenciesTypeOf.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated.js';
import { createPolynomialRoot } from '../../factoriesAny.js';
export var polynomialRootDependencies = {
  addDependencies,
  cbrtDependencies,
  divideDependencies,
  equalScalarDependencies,
  imDependencies,
  isZeroDependencies,
  multiplyDependencies,
  reDependencies,
  sqrtDependencies,
  subtractDependencies,
  typeOfDependencies,
  typedDependencies,
  unaryMinusDependencies,
  createPolynomialRoot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPolynomialRoot.generated.js
// module id = 1441
// module chunks = 2